import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "eg-page" }
const _hoisted_2 = { class: "eg-main" }
const _hoisted_3 = {
  key: 0,
  class: "eg-tabbar"
}
const _hoisted_4 = { class: "eg-tabbar__icon" }
const _hoisted_5 = { class: "eg-tabbar__label" }

import { computed, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { NotificationContainer, Loading } from 'animal-island-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'EnglishGamePage',
  setup(__props) {

const route = useRoute()

/** 首屏加载状态（true 时显示全屏小岛 Loading，主内容隐藏） */
const firstLoading = ref(true)

// 挂载后短暂展示小岛加载动画（等待首页数据初步就绪，最低展示 800ms 避免闪烁）
onMounted(() => {
  window.setTimeout(() => {
    firstLoading.value = false
  }, 800)
})

/** 底部导航菜单项配置（首页 / 排行榜 / 我的） */
const tabs = [
  { path: '/', label: '首页', icon: '🏠' },
  { path: '/ranking', label: '排行榜', icon: '🏆' },
  { path: '/profile', label: '我的', icon: '👤' },
]

/**
 * 函数功能：判断底部导航是否显示（学生登录页隐藏导航）
 * 输入参数：无（读取当前路由路径）
 * 输出参数：无（computed 布尔值）
 * 返回值：boolean —— 当前路由非 /login 时为 true
 */
const showTabBar = computed((): boolean => route.path !== '/login')

/**
 * 函数功能：判断指定导航项是否处于激活态
 * 输入参数：path —— 导航项目标路径（string）
 * 输出参数：无（返回布尔结果）
 * 返回值：boolean —— 当前路由路径与目标路径一致时为 true
 */
function isActive(path: string): boolean {
  return route.path === path
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Loading), {
      active: firstLoading.value,
      class: "eg-first-loading"
    }, null, 8, ["active"]),
    _withDirectives(_createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view)
    ], 512), [
      [_vShow, !firstLoading.value]
    ]),
    (showTabBar.value)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
            return _createVNode(_component_router_link, {
              key: tab.path,
              to: tab.path,
              class: _normalizeClass(["eg-tabbar__item", { 'is-active': isActive(tab.path) }])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(tab.icon), 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(tab.label), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"])
          }), 64))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(NotificationContainer))
  ]))
}
}

})